import { lazy, Suspense } from 'react'

import { createFileRoute } from '@tanstack/react-router'

import { Subtitle, Title } from '@/shared/auth/components/common/card'

import { Skeleton } from '@/components/ui/skeleton'

const SetupTOTPForm = lazy(
	() => import('@/shared/auth/components/forms/setup-totp'),
)

export const Route = createFileRoute('/onboarding/setup-totp')({
	head: () => ({
		meta: [
			{
				title: 'Setup Time-Based One-Time Password | BitLyft AIR®',
			},
		],
	}),

	component: RouteComponent,
	pendingComponent: RoutePendingComponent,
})

function RouteComponent() {
	return (
		<>
			<Title>Setup Two-Factor Authentication</Title>
			<Subtitle className="text-center">
				Scan QR code with authenticator app to receive one time code for this
				platform
			</Subtitle>

			<Suspense fallback={<FormSkeleton />}>
				<SetupTOTPForm />
			</Suspense>
		</>
	)
}

function RoutePendingComponent() {
	return (
		<>
			<Title>Setup Two-Factor Authentication</Title>
			<Subtitle className="text-center">
				Scan QR code with authenticator app to receive one time code for this
				platform
			</Subtitle>

			<FormSkeleton />
		</>
	)
}

function FormSkeleton() {
	return (
		<div className="my-4 flex w-full flex-col items-center justify-center">
			<Skeleton className="size-32" />

			<div className="my-4 flex flex-col items-center justify-center text-center">
				<div className="text-text-secondary mb-2 text-sm leading-5 font-light">
					<Skeleton className="mt-4 h-2 w-32" />
				</div>

				<div className="bg-background relative flex flex-row items-center justify-center gap-2 rounded-md p-2 px-4 font-mono text-sm">
					<Skeleton className="h-10 w-72" />
				</div>
			</div>

			<Skeleton className="h-10 w-full" />

			<Skeleton className="h-10 w-full" />
		</div>
	)
}
